import { render, staticRenderFns } from "./search_.vue?vue&type=template&id=531c2366&scoped=true&"
import script from "./search_.vue?vue&type=script&lang=js&"
export * from "./search_.vue?vue&type=script&lang=js&"
import style0 from "./search_.vue?vue&type=style&index=0&id=531c2366&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531c2366",
  null
  
)

export default component.exports